import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {DashboardGestao} from "../models/dashboard-gestao";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaPlano} from "../../cadastro/models/lista-plano";
import {Dashboard} from "../../home/models/dashboard";
import {DashboardAdvogado} from "../../home/models/dashboardAdvogado";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`DashboardService`);
  }

  baseUrl = environment.apiUrl;

  buscarDashboardGestao(): Observable<BaseResponse<DashboardGestao> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<DashboardGestao>>(`${this.baseUrl}/Dashboard/Gestao`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarDashboardGestao')));
  }

  buscarDashboardAdvogado(): Observable<BaseResponse<DashboardAdvogado> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<DashboardAdvogado>>(`${this.baseUrl}/Dashboard/Advogados`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarDashboardGestao')));
  }

  buscarDashboardInicial(): Observable<BaseResponse<Dashboard> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<Dashboard>>(`${this.baseUrl}/Dashboard/Inicial`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarDashboardInicial')));
  }
}
